import {
  ItAccreditationResponseOrgStatusDictionary,
  ItAccreditationResponseOrgStatusEnum,
} from 'APIPackage/KnmModule/enums/ItAccreditationResponseOrgStatusEnum';

import { RenderFunc } from '../types/RenderFunc';

export const renderItAccreditationStatus: RenderFunc = item => {
  const { newValue, oldValue } = item;

  const stringOldValue = ((typeof oldValue === 'string' ? oldValue : '').toString() ||
    'UNKNOWN') as ItAccreditationResponseOrgStatusEnum;
  const stringNewValue = ((typeof newValue === 'string' ? newValue : '').toString() ||
    'UNKNOWN') as ItAccreditationResponseOrgStatusEnum;

  return {
    renderedOldValue: ItAccreditationResponseOrgStatusDictionary[stringOldValue],
    renderedNewValue: ItAccreditationResponseOrgStatusDictionary[stringNewValue],
  };
};
